import styled from '@emotion/styled'

import type { FC, PropsWithChildren } from 'react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const Filters: FC<PropsWithChildren> = ({ children }) => {
  return (
    <StyledSectionBase variant="noCopy">
      <Section.Contents>
        <StyledColumnTrack columns={1} overrides={{ md: 3 }} gap="small">
          {children}
        </StyledColumnTrack>
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
  position: relative;
  z-index: 1;
  ${Section.Wrapper} {
    padding: 40px 24px;
    justify-content: center;
  }
`

const StyledColumnTrack = styled(ColumnTrack)`
  row-gap: 16px;
  justify-content: center;
  max-width: 828px;
  margin: 0 auto;
`

export default Filters
